import type { FaireProductEntity } from "../../entity_types/product";

export const p_xnnfex2twa: FaireProductEntity = {
  token: "p_xnnfex2twa",
  type: "product",
  name: "Craft Glass Soda | Jarritos Strawberry 24 Count",
  brandToken: "b_6w2wcf7tpu",
  brandName: "Mr. YuYu's Chililicious Candy",
  imageUrl: "https://cdn.faire.com/fastly/f08b9b08d4ab5198ecc3f1aeab895fb27800eca53cc2b41a03e37ac7e8f6db41.jpeg",
  galleryImageUrls: [],
  priceDollars: 59.53,
  description: "Expand your beverage lineup with Jarritos Strawberry 24 Count, featuring the brand’s authentic strawberry flavor in premium glass bottles.\n\nCrafted with natural ingredients and lively carbonation, each bottle delivers a sweet, refreshing taste that appeals to a wide range of consumers. The glass packaging preserves flavor and carbonation while offering a sophisticated presentation for retail, food service, and hospitality environments.\n\nIdeal for wholesale distributors, restaurants, convenience stores, and specialty retailers, Jarritos Strawberry provides consistent quality and strong brand recognition for your inventory.\n\nKey Features\n\n * 24-count Jarritos Strawberry soda in glass bottles \n * Authentic strawberry flavor with vibrant carbonation \n * Made with natural ingredients \n * Premium glass packaging for freshness and shelf appeal \n * Ideal for retail, hospitality, and wholesale \n * Distributed by Mr YuYu’s Wholesale ",
  tags: [],
  msrpDollars: 119.06,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:55.174Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
